import { IncomingHttpHeaders } from 'http';
// eslint-disable-next-line import/no-unresolved
import { Methods } from '@doda/api-client/aspida/api/v1/job/_jid@string/relationInfoList/_corporateClientId@string';
import { apiClient } from '@doda/api-client/util/apiClient';

export type RelationInfoListQuery = NonNullable<Methods['get']['query']>;

export const getRelationInfoList = async ({
  jid,
  corporateClientId,
  params,
  headers,
}: {
  jid: string;
  corporateClientId: string;
  params: RelationInfoListQuery;
  headers?: IncomingHttpHeaders;
}) => {
  return apiClient.api.v1.job
    ._jid(jid)
    .relationInfoList._corporateClientId(corporateClientId)
    .$get({
      query: params,
      config: {
        headers,
      },
    })
    .catch();
};
